// Vista que muestra el metodo de pago seleccionado
// Todas la vistas estan en el componete <SelectPayment/> donde validas y despliega la vista seleccionada
import React, { useState } from "react";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import SelectPayment from "./typePayments/SelectPayment";
function Step4({
  stapsState,
  setStapsState,
  deatils,
  stespData,
  setStespData,
}) {
  const [loading, setLoading] = useState(false);
  const atras = () => {
    setStespData({
      ...stespData,
      backStep4: true,
    });
    setStapsState({
      ...stapsState,
      option1: false,
      option2: false,
      option3: true,
      option4: false,
    });
  };

  return (
    <div className="w-full flex-col flex gap-5">
      {loading ? (
        <>
          <div className="h-[50vh] flex justify-center item-center ">
            <Spinner />
          </div>
        </>
      ) : (
        <>
          <div>
            <SelectPayment
              data={stespData}
              setData={setStespData}
              stapsState={stapsState}
              setStapsState={setStapsState}
              back={atras}
              deatils={deatils}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Step4;
